import { FaSass, FaBootstrap, FaAws, FaTools } from "react-icons/fa";

import {
  SiStyledcomponents,
  SiFlask,
  SiDjango,
  SiJavascript,
  SiPython,
  SiReact,
  SiRedux,
  SiGithub,
  SiHeroku,
  SiFirebase,
  SiPostgresql,
  SiMysql,
  SiCss3,
  SiHtml5,
  SiNextdotjs,
  SiVuedotjs,
  SiTypescript,
  SiTailwindcss,
  SiGraphql,
  SiApollographql,
  SiExpo,
  SiJest,
  SiC,
  SiSqlite,
  SiSelenium,
  SiMarkdown,
  SiGooglemaps,
  SiCypress,
  SiNodedotjs,
  SiExpress,
  SiMongodb,
  SiNpm,
  SiStorybook,
  SiVite,
  SiDocker,
  SiTestinglibrary,
  SiEslint,
  SiKubernetes,
  SiGitlab,
  SiReactrouter,
  SiStripe,
  SiSocketdotio,
  SiOpenai,
  SiNuxtdotjs,
  SiShopify,
  SiPhp,
  SiLaravel,
  SiRedis,
  SiPandas,
  SiNumpy,
  SiPytorch,
  SiLinux,
  SiUbuntu,
  SiTensorflow,
  SiNestjs,
  SiRubyonrails,
  SiGnubash,
  SiSpringboot,
  SiKotlin,
  SiDotnet,
  SiCsharp,
  SiRuby,
  SiAngular,
  SiScratch,
} from "react-icons/si";

import { DiGoogleCloudPlatform, DiJava } from "react-icons/di";

export const StackScratch: StackProps = {
  name: "Scratch",
  Icon: () => <SiScratch />,
  link: "",
  videoId: "",
};

export const StackAngular: StackProps = {
  name: "Angular",
  Icon: () => <SiAngular />,
  link: "",
  videoId: "",
};

export const StackRuby: StackProps = {
  name: "Ruby",
  Icon: () => <SiRuby />,
  link: "",
  videoId: "",
};

export const StackCSharp: StackProps = {
  name: "C#",
  Icon: () => <SiCsharp />,
  link: "",
  videoId: "",
};

export const StackDotnet: StackProps = {
  name: "ASP.NET",
  Icon: () => <SiDotnet />,
  link: "",
  videoId: "",
};

export const StackKotlin: StackProps = {
  name: "Kotlin",
  Icon: () => <SiKotlin />,
  link: "",
  videoId: "",
};

export const StackSpringboot: StackProps = {
  name: "Springboot",
  Icon: () => <SiSpringboot />,
  link: "",
  videoId: "",
};

export const StackJava: StackProps = {
  name: "Java",
  Icon: () => <DiJava />,
  link: "",
  videoId: "",
};

export const StackBash: StackProps = {
  name: "Bash",
  Icon: () => <SiGnubash />,
  link: "",
  videoId: "I4EWvMFj37g",
};

export const StackHTML: StackProps = {
  name: "HTML",
  Icon: () => <SiHtml5 />,
  link: "https://html.spec.whatwg.org/",
  videoId: "ok-plXXHlWw",
};

export const StackCSS: StackProps = {
  name: "CSS",
  Icon: () => <SiCss3 />,
  link: "https://www.w3.org/TR/CSS/#css",
  videoId: "OEV8gMkCHXQ",
};

export const StackTailwindcss: StackProps = {
  name: "TailwindCSS",
  Icon: () => <SiTailwindcss />,
  link: "https://tailwindcss.com/",
  videoId: "mr15Xzb1Ook",
};

export const StackJavascript: StackProps = {
  name: "JavaScript",
  Icon: () => <SiJavascript />,
  link: "https://www.javascript.com/",
  videoId: "DHjqpvDnNGE",
};

export const StackTypescript: StackProps = {
  name: "TypeScript",
  Icon: () => <SiTypescript />,
  link: "https://www.typescriptlang.org/",
  videoId: "zQnBQ4tB3ZA",
};

export const StackReact: StackProps = {
  name: "React",
  Icon: () => <SiReact />,
  link: "https://reactjs.org/",
  videoId: "Tn6-PIqc4UM",
};

export const StackReactNative: StackProps = {
  name: "React Native",
  Icon: () => <SiReact />,
  link: "https://reactnative.dev/",
  videoId: "gvkqT_Uoahw",
};

export const StackRedux: StackProps = {
  name: "Redux",
  Icon: () => <SiRedux />,
  link: "https://redux.js.org/",
  videoId: "_shA5Xwe8_4",
};

export const StackPostgresql: StackProps = {
  name: "PostgreSQL",
  Icon: () => <SiPostgresql />,
  link: "https://www.postgresql.org/",
  videoId: "n2Fluyr3lbc",
};

export const StackNextJS: StackProps = {
  name: "NextJS",
  Icon: () => <SiNextdotjs />,
  link: "https://nextjs.org/",
  videoId: "Sklc_fQBmcs",
};

export const StackVue: StackProps = {
  name: "Vue",
  Icon: () => <SiVuedotjs />,
  link: "https://vuejs.org/",
  videoId: "nhBVL41-_Cw",
};

export const StackNuxt: StackProps = {
  name: "NuxtJS",
  Icon: () => <SiNuxtdotjs />,
  link: "",
  videoId: "dCxSsr5xuL8",
};

export const StackRails: StackProps = {
  name: "Ruby on Rails",
  Icon: () => <SiRubyonrails />,
  link: "",
  videoId: "UYm0kfnRTJk",
};

export const StackNest: StackProps = {
  name: "NestJS",
  Icon: () => <SiNestjs />,
  link: "",
  videoId: "0M8AYU_hPas",
};

export const StackTensorFlow: StackProps = {
  name: "TensorFlow",
  Icon: () => <SiTensorflow />,
  link: "",
  videoId: "i8NETqtGHms",
};

export const StackUbuntu: StackProps = {
  name: "Ubuntu",
  Icon: () => <SiUbuntu />,
  link: "",
};

export const StackLinux: StackProps = {
  name: "Linux",
  Icon: () => <SiLinux />,
  link: "",
  videoId: "rrB13utjYV4",
};

export const StackPyTorch: StackProps = {
  name: "PyTorch",
  Icon: () => <SiPytorch />,
  link: "",
  videoId: "ORMx45xqWkA",
};

export const StackNumpy: StackProps = {
  name: "NumPy",
  Icon: () => <SiNumpy />,
  link: "",
};

export const StackPandas: StackProps = {
  name: "Pandas",
  Icon: () => <SiPandas />,
  link: "",
};

export const StackGCP: StackProps = {
  name: "Google Cloud Platform",
  Icon: () => <DiGoogleCloudPlatform />,
  link: "",
};

export const StackRedis: StackProps = {
  name: "Redis",
  Icon: () => <SiRedis />,
  link: "",
  videoId: "G1rOthIU-uo",
};

export const StackLaravel: StackProps = {
  name: "Laravel",
  Icon: () => <SiLaravel />,
  link: "",
  videoId: "rIfdg_Ot-LI",
};

export const StackPHP: StackProps = {
  name: "PHP",
  Icon: () => <SiPhp />,
  link: "",
  videoId: "a7_WFUlFS94",
};

export const StackShopify: StackProps = {
  name: "Shopify",
  Icon: () => <SiShopify />,
  link: "",
};

export const StackChatGPT: StackProps = {
  name: "ChatGPT",
  Icon: () => <SiOpenai />,
  link: "",
};

export const StackSocketIO: StackProps = {
  name: "SocketIO",
  Icon: () => <SiSocketdotio />,
  link: "",
};

export const StackStripe: StackProps = {
  name: "Stripe",
  Icon: () => <SiStripe />,
  link: "",
};

export const StackReactRouter: StackProps = {
  name: "React Router",
  Icon: () => <SiReactrouter />,
  link: "",
};

export const StackGitlab: StackProps = {
  name: "Gitlab",
  Icon: () => <SiGitlab />,
  link: "",
};

export const StackKubernetes: StackProps = {
  name: "Kubernetes",
  Icon: () => <SiKubernetes />,
  link: "",
  videoId: "PziYflu8cB8",
};

export const StackTestingLibrary: StackProps = {
  name: "Testing Library",
  Icon: () => <SiTestinglibrary />,
  link: "",
};

export const StackEslint: StackProps = {
  name: "ESLint",
  Icon: () => <SiEslint />,
  link: "",
};

export const StackCICD: StackProps = {
  name: "CI/CD",
  Icon: () => <FaTools />,
  link: "",
};

export const StackDocker: StackProps = {
  name: "Docker",
  Icon: () => <SiDocker />,
  link: "",
  videoId: "Gjnup-PuquQ",
};

export const StackVite: StackProps = {
  name: "Vite",
  Icon: () => <SiVite />,
  link: "",
};

export const StackStorybook: StackProps = {
  name: "Storybook",
  Icon: () => <SiStorybook />,
  link: "",
};

export const StackNPM: StackProps = {
  name: "NPM",
  Icon: () => <SiNpm />,
  link: "",
};

export const StackMongodb: StackProps = {
  name: "MongoDB",
  Icon: () => <SiMongodb />,
  link: "",
  videoId: "-bt_y4Loofg",
};

export const StackExpress: StackProps = {
  name: "Express",
  Icon: () => <SiExpress />,
  link: "",
};

export const StackNode: StackProps = {
  name: "NodeJS",
  Icon: () => <SiNodedotjs />,
  link: "",
  videoId: "ENrzD9HAZK4",
};

export const StackCypress: StackProps = {
  name: "Cypress",
  Icon: () => <SiCypress />,
  link: "https://www.cypress.io/",
};

export const StackGoogleMaps: StackProps = {
  name: "Google Maps",
  Icon: () => <SiGooglemaps />,
  link: "https://developers.google.com/maps",
};

export const StackMarkdown: StackProps = {
  name: "Markdown",
  Icon: () => <SiMarkdown />,
  link: "https://www.markdownguide.org/",
};

export const StackSelenium: StackProps = {
  name: "Selenium",
  Icon: () => <SiSelenium />,
  link: "https://www.selenium.dev/",
};

export const StackSqlite: StackProps = {
  name: "SQLite",
  Icon: () => <SiSqlite />,
  link: "https://www.sqlite.org/index.html",
};

export const StackC: StackProps = {
  name: "C",
  Icon: () => <SiC />,
  link: "https://en.wikipedia.org/wiki/C_(programming_language)",
  videoId: "U3aXWizDbQ4",
};

export const StackJest: StackProps = {
  name: "Jest",
  Icon: () => <SiJest />,
  link: "https://jestjs.io/pt-BR/",
};

export const StackGraphql: StackProps = {
  name: "GraphQL",
  Icon: () => <SiGraphql />,
  link: "https://graphql.org/",
  videoId: "eIQh02xuVw4",
};

export const StackApollo: StackProps = {
  name: "Apollo",
  Icon: () => <SiApollographql />,
  link: "https://www.apollographql.com/",
};

export const StackExpo: StackProps = {
  name: "Expo",
  Icon: () => <SiExpo />,
  link: "https://expo.dev/",
};

export const StackSass: StackProps = {
  name: "Sass",
  Icon: () => <FaSass />,
  link: "https://sass-lang.com/",
};

export const StackBootstrap: StackProps = {
  name: "Bootstrap",
  Icon: () => <FaBootstrap />,
  link: "https://getbootstrap.com/",
};

export const StackAWS: StackProps = {
  name: "AWS",
  Icon: () => <FaAws />,
  link: "https://aws.amazon.com/",
  videoId: "ZzI9JE0i6Lc",
};

export const StackMySQL: StackProps = {
  name: "MySQL",
  Icon: () => <SiMysql />,
  link: "https://www.mysql.com/",
  videoId: "Cz3WcZLRaWc",
};

export const StackGithubActions: StackProps = {
  name: "Github Actions",
  Icon: () => <SiGithub />,
  link: "https://github.com/features/actions",
};

export const StackGithubPages: StackProps = {
  name: "Github Pages",
  Icon: () => <SiGithub />,
  link: "https://pages.github.com/",
};

export const StackDjango: StackProps = {
  name: "Django",
  Icon: () => <SiDjango />,
  link: "https://www.djangoproject.com/",
};

export const StackPython: StackProps = {
  name: "Python",
  Icon: () => <SiPython />,
  link: "https://www.python.org/",
  videoId: "x7X9w_GIm1s",
};

export const StackFlask: StackProps = {
  name: "Flask",
  Icon: () => <SiFlask />,
  link: "https://flask.palletsprojects.com/",
};

export const StackHeroku: StackProps = {
  name: "Heroku",
  Icon: () => <SiHeroku />,
  link: "https://www.heroku.com/home",
};

export const StackStyledComponents: StackProps = {
  name: "Styled Components",
  Icon: () => <SiStyledcomponents />,
  link: "https://styled-components.com/",
};

export const StackFirebase: StackProps = {
  name: "Firebase",
  Icon: () => <SiFirebase />,
  link: "https://firebase.google.com/",
  videoId: "vAoB4VbhRzM",
};
